import React, { useState } from "react";



interface Props {
  text: string;
  limit?: number;
}

const ViewMoreText: React.FC<Props> = ({ text, limit = 40 }) => {
  const [expanded, setExpanded] = useState(false);

  if (text.length <= limit) return <span>{text}</span>;

  return (
    <span>
      {expanded ? text : text.substring(0, limit) + "... "}
      <button
        type="button"
        className="view-more-btn "
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "View Less" : "View More"}
      </button>
    </span>
  );
};

export default ViewMoreText;